import React from 'react';

import { Grid, Skeleton } from '@mantine/core';

export function SmartAssistantLoadingSkeleton() {
  const skeletons = Array.from(Array(30).keys());
  return (
    <Grid p="md" gutter="lg" w="98%">
      {skeletons.map((_, key: number) => {
        return (
          <Grid.Col span="content" key={key}>
            <Skeleton height={80} width={220} />
          </Grid.Col>
        );
      })}
    </Grid>
  );
}
